import { defaultRegion } from "common/config";
import { atom } from "jotai";

export const filtersOpenAtom = atom<boolean>(false);
export const mapVisibleOnMobileAtom = atom<boolean>(true);
export const leftPanelExpandedAtom = atom<boolean>(true);

export const mobileListViewAtom = atom<boolean>(true);

// Tracks where the mobile venue detail was opened from (list or map), so the
// back action can return the user to the same view. Shared by the search page
// and the What's Nearby map.
export const mapDetailOriginAtom = atom<"list" | "map">("list");

export const venueDetailsOpenedAtom = atom<boolean>(false);
export const searchVenueAtom = atom<string>("");
export const searchTermInputAtom = atom<string>("");
export const mapCenterAtom = atom({
  lat: defaultRegion.latitude,
  lng: defaultRegion.longitude,
});

// Live map viewport (centre + NE/SW bounds), kept in sync by BasicMapView so the
// venue-list map-mode toggle can search the current viewport without a map ref.
export type MapViewport = {
  lat: number;
  lng: number;
  ne: { lat: number; lng: number };
  sw: { lat: number; lng: number };
  zoom: number;
} | null;
export const mapViewportAtom = atom(null as MapViewport);
export const savedPlaceIdToViewAtom = atom<string>("");
export const savedPlaceByUserIdToViewAtom = atom<string>("");
export const savedPlaceSortByToViewAtom = atom<string>("");
export const savedPlaceIdToViewDataChangedAtom = atom<boolean>(false);
export const hoveredVenueIdAtom = atom<string>("");
export const viewModeAtom = atom<"mapper" | "user">("mapper");
export const searchOverlayOpenAtom = atom<boolean>(false);
export const activeSavedSearchIdAtom = atom(null as string | number | null);

// Google place_id selected on the home page (no map). BasicMapView reads it on
// mount and dispatches selectGooglePlace. Empty string = nothing pending.
export const pendingGooglePlaceIdAtom = atom<string>("");

// Bumped when a deliberate area/category search is dispatched from the search bar.
export const fitMapToResultsAtom = atom<number>(0);

// Stores a JSON-serialised compound search selected on the home page.
// Shape: { locationQuery: string, searchTerm: string, matchedBusinessType: string | null }
// BasicMapView reads this on mount, geocodes locationQuery, pans, and runs the search.
// Empty string means "nothing pending".
export const pendingCompoundSearchAtom = atom<string>("");

// Bridges the desktop home page's "view all" actions (e.g. "Mapped places near you") to the
// /search route landing with real results. Set to `true` right before navigating away from the
// home page, and cleared by the search page once its own venue query settles — this covers the
// otherwise-visible empty/incomplete flash during the route transition + initial data fetch.
// `__root.tsx` also enforces a safety-timeout fallback in case the search page never clears it.
export const isSearchNavigationLoadingAtom = atom<boolean>(false);
